import EditOrganization from './EditOrganization';

export default EditOrganization;



// WEBPACK FOOTER //
// ./src/components/Modals/EditOrganization/index.jsx